import type { ThemeConfig } from 'antd';

import { BORDER, COLOR, CONTROL, FONT, RADIUS, SPACE } from '../tokens';

// Translates tokens into antd's ThemeConfig. Passes SEED tokens only — antd derives ~490 further
// values from these, and writing a derived value here would silently pin it so it stops tracking
// the seed. The seeds-only guard in tokens.test.ts enforces that.
//
// Deliberately not set: `fontFamily`. antd currently renders its stock system stack, and
// `.custom-fonts-enabled` already forces the app FONT with !important, so setting it here would be
// a visual change with no benefit. Tracked in UNRESOLVED_CONFLICTS.FONT_FAMILY.
export const ANTD_THEME: ThemeConfig = {
  token: {
    colorPrimary: COLOR.BRAND.PRIMARY,
    colorSuccess: COLOR.SEMANTIC.SUCCESS,
    colorWarning: COLOR.SEMANTIC.WARNING,
    colorError: COLOR.SEMANTIC.ERROR,
    colorInfo: COLOR.SEMANTIC.INFO,
    colorLink: COLOR.SEMANTIC.LINK,

    borderRadius: RADIUS.MD,
    fontSize: FONT.SIZE.MD,
    controlHeight: CONTROL.HEIGHT.MD,
    lineWidth: BORDER.WIDTH,
    sizeUnit: SPACE.UNIT,
    sizeStep: SPACE.STEP,
  },
};

// Density-aware variant. antd derives every control size from the `controlHeight` seed, so switching
// this one value gives touch layouts a taller Select/Input/Button without per-component overrides.
// Both values are existing CONTROL steps, not new numbers.
export const antdThemeFor = (isTouch: boolean): ThemeConfig => ({
  ...ANTD_THEME,
  token: {
    ...ANTD_THEME.token,
    controlHeight: isTouch ? CONTROL.HEIGHT.LG : CONTROL.HEIGHT.MD,
  },
});

// The two public-facing form pages run their own brand colour. Recorded as-is rather than merged;
// unifying it is a separate visual change. Tracked in UNRESOLVED_CONFLICTS.BRAND_PRIMARY.
export const PUBLIC_FORM_THEME: ThemeConfig = {
  token: {
    ...ANTD_THEME.token,
    colorPrimary: '#1B9AD8',
    colorPrimaryHover: '#157FB4',
  },
};
